import React from "react";

import HeroSection from "../components/home/HeroSection";
import OutcomeSection from "../components/home/OutcomeSection";

import ServicesPreview from "../components/home/ServicesPreview";
import IndustriesPreview from "../components/home/IndustriesPreview";
import CaseStudiesPreview from "../components/home/CaseStudiesPreview";
import BlogPreview from "../components/home/BlogPreview";

import TrustBar from "../components/sections/TrustBar";
import GrowthFramework from "../components/sections/GrowthFramework";
import WhoWeWorkWith from "../components/sections/WhoWeWorkWith";
import FAQSection from "../components/sections/FAQSection";
import CTASection from "../components/sections/CTASection";

import Seo from "../seo/Seo";
import pageMeta from "../data/pageMeta";

function HomePage() {
  return (
    <>
      <Seo
        title={pageMeta.home.title}
        description={pageMeta.home.description}
      />
      <HeroSection />

      <TrustBar />

      <OutcomeSection />

      <GrowthFramework />

      <ServicesPreview />

      <IndustriesPreview />

      <WhoWeWorkWith />

      <CaseStudiesPreview />

      <BlogPreview />

      <FAQSection />

      <CTASection />
    </>
  );
}

export default HomePage;